export default __webpack_public_path__ + "static/media/640_dummy2016-reiseblog01-mobile-de.0b62c02c.png";